module.exports = __webpack_public_path__ + "img/mk.c8fb5218.svg";